import { AttendanceDto  } from "@gtpl/shared-models/gtpl";
import { GlobalResponseObject } from '@gtpl/shared-models/common-models';

export class AttendanceResponseModel extends GlobalResponseObject{
    data?: AttendanceDto[];
    otdata?: AttendanceDto[];
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: AttendanceDto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}
